// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__360Ht","col":"styles_col__38t9C","actions":"styles_actions__zgIoa","conflict":"styles_conflict__2f_0d"};